import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataDeductionSubTypesDTO } from "@src/domain/dto/masterData";

export class GetMasterDataDeductionSubTypesUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataDeductionSubTypesDTO) {
    return this.repository.getDeductionSubTypes(params);
  }
}
